import { Box, Heading, Stack, Text } from 'braid-design-system';
import type { ComponentProps, ElementType } from 'react';

interface ResultTemplateProps {
  heading: string;
  description: ComponentProps<typeof Stack>['children'] | string;
  Illustration?: ElementType;
  Actions?: ElementType;
  'data-automation'?: string;
}

const ResultTemplate = ({
  heading,
  description,
  Actions,
  Illustration,
  'data-automation': dataAutomation,
}: ResultTemplateProps) => (
  <Box
    paddingY="xlarge"
    paddingX={{ mobile: 'medium', tablet: 'gutter' }}
    background="surface"
    data-automation={dataAutomation}
  >
    <Stack space="gutter" align="center">
      {Illustration && <Illustration />}
      <Heading level="3" align="center">
        {heading}
      </Heading>
      {typeof description === 'string' ? (
        <Text align="center">{description}</Text>
      ) : (
        description
      )}
      {Actions && <Actions />}
    </Stack>
  </Box>
);

export default ResultTemplate;
